import { render, staticRenderFns } from "./AirlineFields.vue?vue&type=template&id=2181002a"
import script from "./AirlineFields.vue?vue&type=script&lang=js"
export * from "./AirlineFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports